import { h, clear } from './dom.js';
import { SHORTCUTS } from '../core/shortcuts.js';

// Floating cheat-sheet, toggled with `?`. Click the backdrop or press Esc
// to dismiss.

export function mountShortcutsPanel() {
    const list = h('ul.shortcut-list');
    for (const s of SHORTCUTS) {
        list.appendChild(h('li', {}, [
            h('kbd.shortcut-key', {}, s.keys),
            h('span.shortcut-desc', {}, s.desc),
        ]));
    }

    const card = h('div.shortcut-card', {
        onClick: (e) => e.stopPropagation(),
    }, [
        h('h2', {}, 'Keyboard shortcuts'),
        list,
        h('p.shortcut-foot', {}, 'Press ? again, click outside, or hit Esc to close.'),
    ]);

    const backdrop = h('div.shortcut-backdrop.hidden', {
        onClick: () => hide(),
    }, [card]);
    document.body.appendChild(backdrop);

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !backdrop.classList.contains('hidden')) {
            e.preventDefault();
            hide();
        }
    });

    function show() { backdrop.classList.remove('hidden'); }
    function hide() { backdrop.classList.add('hidden'); }
    function toggle() {
        if (backdrop.classList.contains('hidden')) show(); else hide();
    }
    return { show, hide, toggle };
}
